/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputChatChannel
 */
export interface OutputChatChannel {
    /**
     * 
     * @type {number}
     * @memberof OutputChatChannel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputChatChannel
     */
    name: string;
}

/**
 * Check if a given object implements the OutputChatChannel interface.
 */
export function instanceOfOutputChatChannel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputChatChannelFromJSON(json: any): OutputChatChannel {
    return OutputChatChannelFromJSONTyped(json, false);
}

export function OutputChatChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputChatChannelToJSON(value?: OutputChatChannel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

